import React from 'react';

import {colors} from '../../colors/colors';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AccountCircleIconSVG from './icon-account-circle.svg';

type Props = {
    color?: string;
};

function SvgComponent(props: Props) {
    const validProps = Object.assign({}, props);
    // @ts-expect-error
    delete validProps.styles;

    return <AccountCircleIconSVG {...validProps} color={props.color || colors.company} />;
}

SvgComponent.iconName = 'accounts-circle';

/**
 * @deprecated This is a legacy icon
 */
export const AccountsCircleIcon = svgIconWrapper(SvgComponent);
